import { render, staticRenderFns } from "./hello copy.vue?vue&type=template&id=617ec850&"
import script from "./hello copy.vue?vue&type=script&lang=js&"
export * from "./hello copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports